export default __webpack_public_path__ + "static/media/DNo.15-3.9637b64d.jpg";